import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  selected: {}
};

const noteSlice = createSlice({
  name: "note",
  initialState,
  reducers: {
    setNoteList: (state, {payload}) => {
        state.list = payload
    },
    addNote:(state, {payload}) => {
      state.list = [...state.list, payload]
    },
    setSelectedNote: (state, {payload}) => {
        state.selected = payload;
    },
    updateNote: (state, {payload}) => {
      state.list = state.list.map(d => {
        if(d.id !== payload.id) return d;
        else return {...d, value:payload.value}
      })
    },
    deleteNote: (state, {payload}) => {
      state.list = state.list.filter(d => d.id !== payload)
    },
    clearSelected: (state) => {
        state.selected = {}
    },
    clear: (state) => {
        state.list = []
        state.selected = {}
    }
  },
});

export const { setNoteList, setSelectedNote, addNote, updateNote, deleteNote, clearSelected, clear } = noteSlice.actions;
export default noteSlice.reducer;